import { render, staticRenderFns } from "./EllipsisMenu.vue?vue&type=template&id=8207c944&scoped=true&lang=pug&"
import script from "./EllipsisMenu.vue?vue&type=script&lang=js&"
export * from "./EllipsisMenu.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisMenu.vue?vue&type=style&index=0&id=8207c944&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8207c944",
  null
  
)

export default component.exports